import React, { useState, useEffect} from 'react';
import { 
  User, Mail, Phone, MapPin, Calendar, Clock,
  Edit, Trash2,  ChevronDown, ChevronUp,
  Check, X, AlertCircle,  Bike
} from 'lucide-react';
import '../css/TRB.css';
import axios from 'axios';

const Diplosmaxplus = () => {
  const [expandedFormId, setExpandedFormId] = useState(null);
  const [editingFormId, setEditingFormId] = useState(null);
   const [formsData, setFormsData] = useState([]);
   const [editedform, setEditedForm] = useState([]);
  
     useEffect(() => {
        const fetchDiplos = async () => {
          console.log('entered here useEffect');
         try {
          const res = await axios.get('/api/diplos');
          console.log('response', res.data);
          setFormsData(res.data);
         } catch (error) {
           console.error("Error fetching diplos-max-plus list:", error);
         }
        };
        fetchDiplos();
      }, []);

  // Sample form data - 3 forms
  // const [formsData, setFormsData] = useState([
  //   {
  //     id: 'FORM-001',
  //     submittedAt: '2024-10-29 10:30 AM',
  //     status: 'Pending',
  //     name: 'Alice Johnson',
  //     email: 'alice.johnson@example.com',
  //     phone: '+1 (555) 123-4567',
  //     state: 'California',
  //     city: 'San Francisco',
  //     preferredDate: '2024-11-15',
  //     preferredTime: '02:00 PM',
     
  //   },
  //   {
  //     id: 'FORM-002',
  //     submittedAt: '2024-10-28 02:15 PM',
  //     status: 'Approved',
  //     name: 'Robert Martinez',
  //     email: 'robert.martinez@example.com',
  //     phone: '+1 (555) 987-6543',
  //     state: 'Texas',
  //     city: 'Austin',
  //     preferredDate: '2024-11-20',
  //     preferredTime: '10:30 AM',
    
  //   },
  //   {
  //     id: 'FORM-003',
  //     submittedAt: '2024-10-27 04:45 PM',
  //     status: 'Rejected',
  //     name: 'Emily Chen',
  //     email: 'emily.chen@example.com',
  //     phone: '+1 (555) 456-7890',
  //     state: 'New York',
  //     city: 'New York City',
  //     preferredDate: '2024-11-10',
  //     preferredTime: '03:00 PM',
     
  //   }
  // ]);

    // Calculate stats dynamically
  const stats = {
    pending: formsData.filter(form => form.status === 'Pending').length,
    approved: formsData.filter(form => form.status === 'Approved').length,
    rejected: formsData.filter(form => form.status === 'Rejected').length
  };

  const toggleForm = (formId) => {
    if (expandedFormId === formId) {
      setExpandedFormId(null);
    } else {
      setExpandedFormId(formId);
      setEditingFormId(null); // Close edit mode when switching forms
    }
  };

   const handleEdit = (formId) => {
        setEditingFormId(editingFormId === formId ? null : formId);
        const form = formsData.find(f => f._id === formId);
        setEditedForm({...form});
        console.log('form', form);
      };
    
      const handleSave = async(formId) => {
        console.log('entered save function');
        
        try {
         const res = await axios.put(`/api/editdiplomaxplus/${formId}`, editedform);
         const updated = res.data;
    
          setFormsData(prev =>
        prev.map(form => (form._id === formId ? updated : form))
      );
        setEditingFormId(null);
        alert('Changes saved successfully!');
        }
       catch(error) {
        console.log('error', error);
        alert('Failed to update');
       }
      };
    
      const handleDelete = async(formId) => {
        if (window.confirm('Are you sure you want to delete this form submission?')) {
          try {
             const res = await axios.delete(`/api/deletediplomaxplus/${formId}`);
            console.log('res', res.data);
            setFormsData(prev => prev.filter(form => form._id != formId));
            console.log('Form deleted:', formId);
          
          alert('Form deleted successfully!');
          }
          catch(error) {
            console.log('failed to delete', error);
            alert('Failed to delete!');
          }
          
        }
      };

  // const handleEdit = (formId) => {
  //   setEditingFormId(editingFormId === formId ? null : formId);
  // };

  // const handleSave = () => {
   
  //   setEditingFormId(null);
  //   alert('Changes saved successfully!');
  // };

  // const handleDelete = (formId) => {
  //   if (window.confirm('Are you sure you want to delete this form submission?')) {
  //     console.log('Form deleted:', formId);
  //     setFormsData(prev => prev.filter(form => form._id!==formId));
  //     alert('Form deleted successfully!');
  //   }
  // };

  const handleAction = async(action, formId) => {
    try {
   const res = await axios.put(`/api/statusdiplos/${formId}`, {status : action});
   console.log('response', res.data);
    setFormsData(prevforms => 
      prevforms.map(form => form._id === formId ? {...form, status: action } : form

      ));
    console.log(`Action: ${action} for Form: ${formId}`);
    alert(`Form ${formId} marked as ${action}!`);
    }
    catch (err) {
      alert('Failed to update');
    }
  };

  return (
    <div className="form-details-container">
      {/* Header Section */}
      <div className="forms-header">
        <div className="header-info">
          <h1>Diplos max plus forms</h1>
          <p>View and manage all forms</p>
        </div>
        <div className="header-stats">
          <div className="stat-badge pending-stat">
            <span className="stat-number">{stats.pending}</span>
            <span className="stat-label">Pending</span>
          </div>
          <div className="stat-badge approved-stat">
            <span className="stat-number">{stats.approved}</span>
            <span className="stat-label">Approved</span>
          </div>
          <div className="stat-badge rejected-stat">
            <span className="stat-number">{stats.rejected}</span>
            <span className="stat-label">Rejected</span>
          </div>
        </div>
      </div>

      {/* Forms List */}
      <div className="forms-list">
        {formsData.map((form) => (
          <div key={form._id} className={`form-card ${expandedFormId === form._id ? 'expanded' : ''}`}>
            {/* Form Card Header - Always Visible */}
            <div className="form-card-header" onClick={() => toggleForm(form._id)}>
              <div className="form-card-left">
                <div className="form-avatar">
                  <User size={24} />
                </div>
                <div className="form-basic-info">
                  <h3 className="form-name">{form.name}</h3>
                  <p className="form-id-text">{form._id}</p>
                </div>
              </div>
              <div className="form-card-right">
                <span className={`form-status-badge ${form.status.toLowerCase()}`}>
                  {form.status}
                </span>
                <span className="form-submitted-time">{new Date(form.submittedAt).toISOString().split('T')[0]}</span>
                <button className="expand-btn">
                  {expandedFormId === form._id ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </button>
              </div>
            </div>

            {/* Form Card Details - Expandable */}
            {expandedFormId === form._id && (
              <div className="form-card-details">
                {/* Action Buttons */}
                <div className="detail-actions">
                  <button className="action-btn secondary" onClick={() => handleEdit(form._id)}>
                    <Edit size={16} />
                    {editingFormId === form._id ? 'Cancel' : 'Edit'}
                  </button>
                  {/* <button className="action-btn secondary">
                    <Download size={16} />
                    Export
                  </button>
                  <button className="action-btn secondary">
                    <Share2 size={16} />
                    Share
                  </button> */}
                  <button className="action-btn danger" onClick={() => handleDelete(form._id)}>
                    <Trash2 size={16} />
                    Delete
                  </button>
                </div>

                {/* Personal Information */}
                <div className="details-section">
                  <div className="section-header">
                    <h3>Personal Information</h3>
                    {editingFormId === form._id && (
                      <button className="save-btn" onClick={() => handleSave(editedform._id)}>
                        <Check size={16} />
                        Save
                      </button>
                    )}
                  </div>
                  
                  <div className="details-grid">
                    <div className="detail-item">
                      <div className="detail-label">
                        <User size={16} className="detail-icon" />
                        <span>Full Name</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="text" 
                          className="detail-input" 
                          defaultValue={editedform.name}
                          onChange={e => setEditedForm({ ...editedform, name: e.target.value })}
                        />
                      ) : (
                        <div className="detail-value">{form.name}</div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <Mail size={16} className="detail-icon" />
                        <span>Email</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="email" 
                          className="detail-input" 
                          defaultValue={editedform.email}
                          onChange={e => setEditedForm({ ...editedform, email: e.target.value })}
                        />
                      ) : (
                        <div className="detail-value">
                          <a href={`mailto:${form.email}`} className="link">
                            {form.email}
                          </a>
                        </div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <Phone size={16} className="detail-icon" />
                        <span>Phone</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="tel" 
                          className="detail-input" 
                          defaultValue={editedform.phone}
                          onChange={e => setEditedForm({ ...editedform, phone: e.target.value })}
                        />
                      ) : (
                        <div className="detail-value">
                          <a href={`tel:${form.phone}`} className="link">
                            {form.phone}
                          </a>
                        </div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <MapPin size={16} className="detail-icon" />
                        <span>State</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="text" 
                          className="detail-input" 
                          defaultValue={editedform.state}
                          onChange={e => setEditedForm({ ...editedform, state: e.target.value })}
                        />
                      ) : (
                        <div className="detail-value">{form.state}</div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <MapPin size={16} className="detail-icon" />
                        <span>City</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="text" 
                          className="detail-input" 
                          defaultValue={editedform.city}
                          onChange={e => setEditedForm({ ...editedform, city: e.target.value })}
                        />
                      ) : (
                        <div className="detail-value">{form.city}</div>
                      )}
                    </div>

                    
                    
                  </div>
                </div>

                {/* Appointment Details */}
                <div className="details-section">
                  <div className="section-header">
                    <h3>Appointment Details</h3>
                  </div>
                  
                  <div className="details-grid appointment-grid">
                    <div className="detail-item">
                      <div className="detail-label">
                        <Calendar size={16} className="detail-icon" />
                        <span>Preferred Date</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="date" 
                          className="detail-input" 
                          defaultValue={editedform.preferredDate}
                          onChange={e => setEditedForm({ ...editedform, preferredDate: e.target.value })}
                        />
                      ) : (
                        <div className="detail-value highlight">
                          {new Date(form.preferredDate).toLocaleDateString('en-US', { 
                            weekday: 'long', 
                            year: 'numeric', 
                            month: 'long', 
                            day: 'numeric' 
                          })}
                        </div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <Clock size={16} className="detail-icon" />
                        <span>Preferred Time</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="time" 
                          className="detail-input" 
                          defaultValue={editedform.preferredTime}
                          onChange={e => setEditedForm({ ...editedform, preferredTime: e.target.value })}
                        />
                      ) : (
                        <div className="detail-value highlight">{form.preferredTime}</div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Quick Actions */}
                <div className="details-section">
                  <div className="section-header">
                    <h3>Quick Actions</h3>
                  </div>
                  
                  <div className="action-grid">
                    <button 
                      className="action-card approved"
                      onClick={() => handleAction('Approved', form._id)}
                    >
                      <Check size={20} />
                      <span>Approve</span>
                    </button>
                    <button 
                      className="action-card rejected"
                      onClick={() => handleAction('Rejected', form._id)}
                    >
                      <X size={20} />
                      <span>Reject</span>
                    </button>
                    <button 
                      className="action-card pending"
                      onClick={() => handleAction('Pending', form._id)}
                    >
                      <AlertCircle size={20} />
                      <span>Pending</span>
                    </button>
                    {/* <button 
                      className="action-card contact"
                      onClick={() => handleAction('Contact', form._id)}
                    >
                      <Mail size={20} />
                      <span>Contact</span>
                    </button> */}
                  </div>
                </div>

                {/* Additional Notes */}
                {/* <div className="details-section">
                  <div className="section-header">
                    <h3>Additional Notes</h3>
                  </div>
                  
                  <div className="notes-container">
                    <textarea 
                      className="notes-textarea" 
                      placeholder="Add any additional notes or comments about this submission..."
                      rows="4"
                    ></textarea>
                    <button className="save-notes-btn">
                      <Check size={16} />
                      Save Notes
                    </button>
                  </div>
                </div> */}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Diplosmaxplus;


